var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5556 6.15385H36L34.2 1.16484C34.0756 0.823451 33.8478 0.528361 33.5475 0.319877C33.2472 0.111392 32.8891 -0.00032012 32.5222 6.89026e-07H15.4778C14.7278 6.89026e-07 14.0556 0.467034 13.8056 1.16484L12 6.15385H4.44444C1.98889 6.15385 0 8.12088 0 10.5495V35.6044C0 38.033 1.98889 40 4.44444 40H43.5556C46.0111 40 48 38.033 48 35.6044V10.5495C48 8.12088 46.0111 6.15385 43.5556 6.15385ZM24 31.2088C19.0889 31.2088 15.1111 27.2747 15.1111 22.4176C15.1111 17.5604 19.0889 13.6264 24 13.6264C28.9111 13.6264 32.8889 17.5604 32.8889 22.4176C32.8889 27.2747 28.9111 31.2088 24 31.2088ZM18.6667 22.4176C18.6667 23.8165 19.2286 25.1582 20.2288 26.1474C21.229 27.1366 22.5855 27.6923 24 27.6923C25.4145 27.6923 26.771 27.1366 27.7712 26.1474C28.7714 25.1582 29.3333 23.8165 29.3333 22.4176C29.3333 21.0186 28.7714 19.677 27.7712 18.6878C26.771 17.6986 25.4145 17.1429 24 17.1429C22.5855 17.1429 21.229 17.6986 20.2288 18.6878C19.2286 19.677 18.6667 21.0186 18.6667 22.4176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.0d4725df74a3ea9f7e2763a1c5e3dd85.svg";
export { ForwardRef as ReactComponent };